import React from "react";
import ColorSwatch from "./ColorSwatch";
import classNames from "../helpers/classNames";

export default function PaletteGrid({
  palette,
  locks = [],
  onToggleLock,
  ohuhuMode,
  showLockIcons = true,
  compactMode = false,
  mobileCompactMode = false,
  replaceMode = false,
  onReplaceSelect
}) {
  // Create a mode key to trigger fade animation on mode change
  const modeKey = mobileCompactMode ? 'mobile' : compactMode ? 'compact' : 'list';

  const gridClasses = classNames(
    "grid",
    mobileCompactMode
      ? "grid-cols-4 gap-3 lg:hidden"
      : compactMode
        ? "grid-cols-4 sm:grid-cols-6 gap-2"
        : "grid-cols-1 lg:grid-cols-2 gap-3 sm:gap-4"
  );

  return (
    <div key={modeKey} className={`${gridClasses} animate-modeFade cursor-pointer`}>
      {palette.map((c, i) => (
        <ColorSwatch
          key={i}
          color={c}
          locked={!!locks[i]}
          onToggleLock={() => (typeof onToggleLock === 'function' ? onToggleLock(i) : undefined)}
          ohuhuMode={ohuhuMode}
          showLockIcons={mobileCompactMode ? false : (replaceMode ? false : showLockIcons)}
          compact={compactMode}
          mobileCompact={mobileCompactMode}
          replaceMode={replaceMode}
          onSelect={replaceMode && typeof onReplaceSelect === 'function' ? () => onReplaceSelect(i) : undefined}
        />
      ))}
    </div>
  );
}
